import type { StylesConfig, GroupBase } from 'react-select';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// constants
import { SearchableSelectType } from '../../inputs/searchableSelect';

export default {
    control: (provided, state) => ({
        ...provided,
        boxShadow: 'none',
        borderColor: state.isFocused
            ? aampeTheme.colors.solidA01
            : aampeTheme.colors.bordersWG01,
        cursor: 'pointer',
        borderRadius: aampeTheme.borderRadius.default,
        '&:hover': {
            borderColor: aampeTheme.colors.solidA01,
        },
        width: '100%',
        ...(state.isDisabled && {
            backgroundColor: aampeTheme.colors.backgroundWG02,
            borderColor: aampeTheme.colors.bordersWG01,
        }),
    }),
    menu: (provided) => ({
        ...provided,
        width: 'fit-content',
        minWidth: '100%',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? aampeTheme.colors.interactiveWG01
            : aampeTheme.colors.white,
        color: aampeTheme.colors.neutral09,
        '&:active': {
            backgroundColor: aampeTheme.colors.interactiveWG01,
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: aampeTheme.colors.white,
        border: `1px solid ${aampeTheme.colors.interactiveWG01}`,
        borderRadius: aampeTheme.borderRadius.default,
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        '&:hover': {
            backgroundColor: aampeTheme.colors.error50,
        },
    }),
    singleValue: (provided, state) => ({
        ...provided,
        ...(state.isDisabled && {
            color: aampeTheme.colors.textAccessibleWG01,
        }),
    }),
} as StylesConfig<
    SearchableSelectType,
    boolean,
    GroupBase<SearchableSelectType>
>;
